export class FinancialSectionConstants {
  public static readonly ENTITY_INCOME_STATEMENT = 'entity_income_statement';
  public static readonly ENTITY_BALANCE_SHEET = 'entity_balance_sheet';
  public static readonly MASTER_FILE_INCOME_STATEMENT = 'master_file_income_statement';
  public static readonly MASTER_FILE_BALANCE_SHEET = 'master_file_balance_sheet';
  public static readonly ENTITY_FINANCIAL_INCOME_STATEMENT = 'entity_financial_income_statement';
  public static readonly ENTITY_FINANCIAL_BALANCE_SHEET = 'entity_financial_balance_sheet';
  public static readonly PBA_INCOME_STATEMENT = 'pba_income_statement';
  public static readonly PBA_BALANCE_SHEET = 'pba_balance_sheet';
}
